import { useMemo } from 'react';
import { Country } from '@tiendanube/common/src/enums';

interface UseFormatIdentification {
  identification: string;
  country: string;
}
interface UseFormatIdentificationByType {
  identification: string;
  type: string;
}

const FORMATS = {
  cpf: '###.###.###-##',
  cnpj: '##.###.###/####-##',
  dni: '##.###.###',
  cuit: '##-########-#',
};

const applyFormat = (value: string, pattern: string) => {
  let i = 0;
  const formatted = pattern.replace(/#/g, () => value[i++] || '');
  return formatted;
};

const BR = (identification: string) => {
  if (identification.length === 11) {
    return applyFormat(identification, FORMATS.cpf);
  } else if (identification.length === 14) {
    return applyFormat(identification, FORMATS.cnpj);
  }

  return identification;
};

const AR = (identification: string) => {
  if (identification.length === 8) {
    return applyFormat(identification, FORMATS.dni);
  } else if (identification.length === 11) {
    return applyFormat(identification, FORMATS.cuit);
  }

  return identification;
};

export const useFormatIdentification = ({
  identification,
  country,
}: UseFormatIdentification) => {
  const formattedIdentification = useMemo(() => {
    const formats = {
      [Country.BR]: BR,
      [Country.AR]: AR,
    };

    if (!formats[country]) return identification;

    return formats[country](identification);
  }, [identification, country]);

  return formattedIdentification;
};

export const useFormatIdentificationByType = ({
  identification,
  type,
}: UseFormatIdentificationByType) => {
  const formattedIdentification = useMemo(() => {
    const pattern = FORMATS[type];
    if (!pattern) return identification;

    return applyFormat(identification, pattern);
  }, [identification, type]);

  return formattedIdentification;
};
